"use client";

import { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faq } from "@/lib/constants";

export default function FAQ() {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="bg-background border-b border-border py-20 md:py-28"
    >
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-14">
          <div className="w-12 h-1 bg-primary mb-5" />
          <h2 className="font-heading text-4xl md:text-5xl font-extrabold text-foreground uppercase tracking-tight">
            FAQ
          </h2>
          <p className="font-sans text-muted-foreground mt-3">
            Everything you need to know about IPTV
          </p>
        </div>

        {/* Accordion */}
        <div className="border-t border-border">
          {faq.map((item, index) => {
            const isOpen = activeIndex === index;
            return (
              <div key={item.id} className="border-b border-border">
                <button
                  onClick={() => setActiveIndex(isOpen ? null : index)}
                  className="w-full flex items-center justify-between py-6 text-left group"
                >
                  <div className="flex items-center gap-5">
                    <span className="font-heading text-xs font-extrabold text-muted-foreground/40 uppercase tracking-widest w-8 shrink-0">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <h3
                      className={`font-heading text-lg md:text-xl font-extrabold uppercase tracking-tight transition-colors duration-200 ${
                        isOpen
                          ? "text-primary"
                          : "text-foreground group-hover:text-primary"
                      }`}
                    >
                      {item.question}
                    </h3>
                  </div>
                  <div
                    className={`shrink-0 ml-4 w-8 h-8 border-2 flex items-center justify-center transition-colors duration-200 ${
                      isOpen
                        ? "border-primary text-primary"
                        : "border-border text-muted-foreground group-hover:border-primary group-hover:text-primary"
                    }`}
                  >
                    {isOpen ? (
                      <Minus className="h-4 w-4" />
                    ) : (
                      <Plus className="h-4 w-4" />
                    )}
                  </div>
                </button>

                <div
                  className={`overflow-hidden transition-all duration-300 ease-in-out ${
                    isOpen ? "max-h-[600px] pb-8" : "max-h-0"
                  }`}
                >
                  <div className="border-l-2 border-primary ml-[52px] pl-5 font-sans text-muted-foreground text-sm leading-relaxed">
                    {item.content}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
